var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 525,
    height: 463,
    viewBox: "0 0 525 463",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_f_531_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.055 81H198.475C156.201 81 117.24 103.884 96.6533 140.807L94.8386 144.061C87.7004 156.863 83.4681 171.08 82.442 185.702L80.8704 208.097C79.1187 233.059 91.9565 256.783 113.811 268.972C124.39 274.871 133.094 283.629 138.929 294.244L146.55 308.107C165.601 342.764 200.554 365.763 239.921 369.544L367.261 381.776C375.684 382.585 384.185 381.867 392.352 379.655C426.462 370.417 448.406 337.287 443.606 302.276L435 239.5L431.299 217.02C424.977 178.622 405.078 143.77 375.222 118.809C346.007 94.3825 309.136 81 271.055 81Z",
    fill: "url(#paint0_radial_531_111)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.055 81H198.475C156.201 81 117.24 103.884 96.6533 140.807L94.8386 144.061C87.7004 156.863 83.4681 171.08 82.442 185.702L80.8704 208.097C79.1187 233.059 91.9565 256.783 113.811 268.972C124.39 274.871 133.094 283.629 138.929 294.244L146.55 308.107C165.601 342.764 200.554 365.763 239.921 369.544L367.261 381.776C375.684 382.585 384.185 381.867 392.352 379.655C426.462 370.417 448.406 337.287 443.606 302.276L435 239.5L431.299 217.02C424.977 178.622 405.078 143.77 375.222 118.809C346.007 94.3825 309.136 81 271.055 81Z",
    stroke: "#B0CCF4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_531_111",
    x: 0.211426,
    y: 0.5,
    width: 524.552,
    height: 462.098,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_531_111"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_531_111",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(265 232) rotate(90) scale(151 187)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2797FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector4.fbedaee62ae9d5bdb5efb919ace78a7c.svg";
export { ForwardRef as ReactComponent };